import type { DayRange } from "./periodRange";

// Период коротко на языке интерфейса: «1–10 окт.», «28 сент. – 3 окт.», один день — «5 окт.».
export const formatDayRange = ({ from, to }: DayRange, locale: string): string =>
  new Intl.DateTimeFormat(locale, { day: "numeric", month: "short" }).formatRange(from, to);
